/**
 * Current React Query cache tiers.
 *
 * By default we have 0 second cache,
 * Use other tiers when data is safe to be stale.
 */

export const CACHE = {
  LIVE: 0,
  SHORT: 10000,
  SESSION: 30000,
  CATALOG: 5 * 60000,
  REFERENCE: Infinity,
};
